import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import BonusInfoModal from '../../components/Casino/BonusInfoModal';

import {
  ackBonusModal
} from '@xanadu/ui-shared/modules/promotions/actions';

const mapDispatchToProps = {
  ackBonusModal,
};

export default withRouter(connect(null, mapDispatchToProps)(BonusInfoModal));
